import { ProspectadorCount } from "../types";

interface Props {
    prospectadores: ProspectadorCount[];
}
export function CounterPerProspectador({ prospectadores }: Props) {

    return(
        <div className="h-full min-w-[264px] border border-gray-300 rounded p-2 bg-slate-100 flex flex-col">
            <p className="font-semibold text-sm">Cantidad de empresas registradas por:</p>

            <div className="overflow-auto h-[52px]">
                {prospectadores.map((count, index) => (
                    <p key={index}>{count.nombre} - {count.total} {count.total == 1 ? "empresa" : "empresas"}</p>
                ))}
            </div>
        </div>
    );
}